<template>
  <div class="actions">
    <ui-button color="primary" outlined @click="$emit('cancel')">{{
      $t("message.common.cancel")
    }}</ui-button>
    <ui-button color="primary" @click="$emit('publish')">{{
      $t("message.reviews.publishAnswer")
    }}</ui-button>
  </div>
</template>
<script>
export default {
  name: "QaListItemComposeActions"
};
</script>
<style lang="scss" scoped>
.actions {
  display: flex;
  gap: $spacing * 1.25;
  justify-content: flex-end;
  margin-bottom: $spacing * 2;
}
</style>
